import { Controller, Path } from 'react-hook-form';
import { Box, TextField } from '@mui/material';
import z from 'zod';
import { FormDatePicker } from 'src/components/date_picker';
import { FormFieldProps } from 'src/distribution_platforms/features/order_form';

export const SamdPatientPhiFormSchema = z.object({
  firstName: z.string().min(1, 'First Name is required'),
  lastName: z.string().min(1, 'Last Name is required'),
  dateOfBirth: z.string().min(1, 'Date of Birth is required'),
});

export type SamdPatientPhiFormData = z.infer<typeof SamdPatientPhiFormSchema>;

export const SamdPatientPhiFormSection = <T extends SamdPatientPhiFormData>({
  control,
  errors,
}: FormFieldProps<T>) => (
  <Box
    data-testid='samd-patient-phi-form-section'
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
    }}
  >
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        gap: 2,
      }}
    >
      <Box
        sx={{
          flex: 1,
        }}
      >
        <Controller
          name={'firstName' as Path<T>}
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              required
              fullWidth
              label='First Name'
              data-testid='samd-patient-first-name'
              error={!!errors.firstName}
              helperText={errors.firstName?.message?.toString() ?? ' '}
            />
          )}
        />
      </Box>
      <Box
        sx={{
          flex: 1,
        }}
      >
        <Controller
          name={'lastName' as Path<T>}
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              required
              fullWidth
              label='Last Name'
              data-testid='samd-patient-last-name'
              error={!!errors.lastName}
              helperText={errors.lastName?.message?.toString() ?? ' '}
            />
          )}
        />
      </Box>
    </Box>
    <Box
      data-testid='samd-patient-date-of-birth'
      sx={{
        flex: 1,
      }}
    >
      <Controller
        name={'dateOfBirth' as Path<T>}
        control={control}
        render={({ field }) => (
          <FormDatePicker
            label='Date of Birth'
            maxDate={new Date()}
            value={field.value}
            required
            fullWidth
            error={!!errors.dateOfBirth}
            helperText={errors.dateOfBirth?.message?.toString() ?? ' '}
            onChange={field.onChange}
            onBlur={field.onBlur}
          />
        )}
      />
    </Box>
  </Box>
);
